import {
  BRIEF_TOOL,
  COPY_AD_TOOL,
  FILL_TOOL,
  GENERATE_TOOL,
  TRANSFER_TOOL,
  VARIATION_TOOL,
} from "../../../../routes.ts";
import type { ModelCompatibleTool } from "../../../Board/types.ts";
import { createWorkspaceSelectedModelsStorage } from "./createWorkspaceSelectedModelsStorage.ts";
import { generativeFillSelectedModelsStorage } from "./generativeFillSelectedModelsStorage.ts";
import type { selectedModelsStorageFactory } from "./selectedModelsStorageFactory.ts";
import { styleTransferSelectedModelsStorage } from "./styleTransferSelectedModelsStorage.ts";
import { variationSelectedModelsStorage } from "./variationSelectedModelsStorage.ts";

export const toolToSelectedModelsStorage: Record<
  ModelCompatibleTool,
  ReturnType<typeof selectedModelsStorageFactory>
> = {
  [GENERATE_TOOL]: createWorkspaceSelectedModelsStorage,
  [BRIEF_TOOL]: createWorkspaceSelectedModelsStorage,
  [TRANSFER_TOOL]: styleTransferSelectedModelsStorage,
  [FILL_TOOL]: generativeFillSelectedModelsStorage,
  [VARIATION_TOOL]: variationSelectedModelsStorage,
  // FIXME: This is a shortcut
  [COPY_AD_TOOL]: createWorkspaceSelectedModelsStorage,
};
